import { Card, CardContent, Box, Typography } from '@mui/material';
import { marked } from 'marked';
import { Layout } from '../components/Layout';
import faqMd from '../../assets/documentation/faq.md?raw';
import { useMeProfile } from '../hooks/useApi';

export function FaqPage() {
  const { data } = useMeProfile();
  const baseUrl = data?.publicDocsBaseUrl ?? '';
  const agreementFile = data?.termsAgreementFilename ?? '';
  const resolved = faqMd
    .split('{{PUBLIC_DOCS_URL}}').join(baseUrl)
    .split('{{TERMS_AGREEMENT_FILENAME}}').join(encodeURIComponent(agreementFile));
  const htmlContent = marked.parse(resolved);

  return (
    <Layout>
      <Card>
        <CardContent>
          <Typography variant="h4" component="h1" gutterBottom>
            Frequently Asked Questions
          </Typography>
          <Box
            sx={{
              '& h2': {
                fontSize: '1.5rem',
                fontWeight: 500,
                marginTop: '2rem',
                marginBottom: '1rem',
                borderBottom: '2px solid',
                borderColor: 'divider',
                paddingBottom: '0.5rem',
              },
              '& h3': {
                fontSize: '1.25rem',
                fontWeight: 500,
                marginTop: '1.5rem',
                marginBottom: '0.75rem',
              },
              '& p': {
                marginTop: '0.5rem',
                marginBottom: '1rem',
                lineHeight: 1.7,
              },
              '& strong': {
                fontWeight: 600,
                color: 'text.primary',
              },
              '& ul': {
                marginTop: '0.5rem',
                marginBottom: '1rem',
                paddingLeft: '2rem',
              },
              '& li': {
                marginBottom: '0.5rem',
                lineHeight: 1.6,
              },
              '& li strong': {
                display: 'block',
                marginBottom: '0.25rem',
              },
              '& a': {
                color: 'primary.main',
                textDecoration: 'underline',
              },
            }}
            dangerouslySetInnerHTML={{ __html: htmlContent as string }}
          />
        </CardContent>
      </Card>
    </Layout>
  );
}
